import React from 'react'
import PropTypes from 'prop-types'

import Button from '../../Button/Button'
import { useDeliveryDistanceValidator } from '../fulfillment-helpers'
import { DINING_OPTION_BEHAVIORS } from '../../../utils/dining-options'

const { DELIVERY } = DINING_OPTION_BEHAVIORS

const getButtonMessage = ({valid, editing, diningOptionBehavior}) => {
  if (!valid && diningOptionBehavior === DELIVERY) return 'View Menu'
  if (editing) return 'Update'
  return 'Start Order'
}

export const FulfillmentFooter = ({ formik, editing }) => {
  const { values, isSubmitting, isValid } = formik
  const { deliveryInfo, diningOptionBehavior } = values
  const { valid, loading } = useDeliveryDistanceValidator(deliveryInfo, diningOptionBehavior)

  return (
    <Button
      data-testid='fulfillment-selector-submit'
      type='submit'
      style='primary'
      loading={isSubmitting || loading}
      disabled={!isValid}
    >
      {getButtonMessage({valid, editing, diningOptionBehavior})}
    </Button>
  )
}

FulfillmentFooter.propTypes = {
  formik: PropTypes.object.isRequired,
  editing: PropTypes.bool
}
